<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'"> 
			<rechargeList></rechargeList>
		</div>
		<div class="add" v-if="type==='add'">
			<recharge></recharge>
			<!-- <div class="settlementBox">
				<ximeiSettlement></ximeiSettlement>
			</div> -->
		</div>
	</div>
</template>
<script>
	import recharge from "./comp/recharge.vue"
	import rechargeList from "./comp/recharge_list.vue"
	export default {
		components:{recharge,rechargeList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.recharge.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.settlementBox{
		position: absolute;
		z-index: 11;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
